import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { CoreService } from '../../core/services/core.service';
import { RouterService } from '../../core/services/router.service';

@Component({
  selector: 'app-home',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})

export class AdminComponent implements OnInit {

  constructor(public core: CoreService, public router: RouterService) {
  }

  ngOnInit(): void {
  }

}
